// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import formatDataForSort from './formatDataForSort'

const sortTableData = (data, { asc, col }) => {
  const formatData = formatDataForSort(col)

  return [...data].sort((a, b) => {
    const [av, bv] = formatData(a, b)

    return (
      !asc
        ? av <= bv ? 1 : -1
        : av >= bv ? 1 : -1
    )
  })
}

export default sortTableData
